<template>
  <div class="analyse">
    <vannav></vannav>
    <div class="box">
      <div class="boxtop">
        <i class="iconfont icon-nengyuanguanli"></i>
        <span>能耗分析</span>
      </div>
      <div class="boxcop">
        <div class="_boxcop" @click="toenergy">
          <i class="iconfont icon-jzfx"></i>
          <span>区域能耗分析</span>
        </div>
        <div class="_boxcop">
          <i class="iconfont icon-shebeizijian" @click="toenergt1"></i>
          <span>设备用能分析</span>
        </div>
        <!-- <div class="_boxcop">
          <i class="iconfont icon-jzfx"></i>
          <span>区域能耗3</span>
        </div>
        <div class="_boxcop">
          <i class="iconfont icon-jzfx"></i>
          <span>区域能耗4</span>
        </div>
        <div class="_boxcop">
          <i class="iconfont icon-jzfx"></i>
          <span>区域能耗5</span>
        </div>
        <div class="_boxcop">
          <i class="iconfont icon-jzfx"></i>
          <span>区域能耗6</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    toenergy() {
      this.$router.push({ path: "/energy" });
    },
    toenergt1() {
      this.$router.push({ path: "/equipment" });
    }
  }
};
</script>

<style scoped lang="less">
.analyse {
  background-color: rgb(190, 190, 190);
  // height: auto;
  width: 100%;
}
.box {
  // width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .boxtop {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #ccc;
    box-shadow: 1px 1px 1px #ccc;
    height: 50px;
    width: 100%;
    margin: auto;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    & > i {
      font-size: 25px;
      margin-right: 5px;
    }
  }
  .boxcop {
    margin-top: 10px;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    flex-wrap: wrap;
    ._boxcop {
      width: 25%;
      align-self: flex-start;
      display: flex;
      flex-direction: column;
      & > i {
        font-size: 50px;
      }
    }
  }
}
</style>
